import { render, staticRenderFns } from "./ModalDesactivarRegistro.vue?vue&type=template&id=840ba348&scoped=true"
import script from "./ModalDesactivarRegistro.vue?vue&type=script&lang=js"
export * from "./ModalDesactivarRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840ba348",
  null
  
)

export default component.exports